/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useState, useCallback } from 'react';
import Pagination from '../../components/Pagination';
import 'tw-elements';
import { useLocation, useSearchParams } from 'react-router-dom';
import ItemShimmer from '../../components/Shimmer/itemShimmer';
import SearchEmptyScreen from '../../components/SearchEmptyScreen';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmationPrompt from '../../components/ConfirmationPrompt';
import AnimatedModel from '../../components/Animation/AnimatedModel';
import { dataService } from '../../services/data.services';
import GlobalContext from '../../components/Context/GloablContext';
import Table from './Components/Table';
import TopBarWithShadow from '../../components/TopBar/TopBarWithShadow';
import { InstitutionUsers } from './institutionUserSlice';
import EmptyScreenBranch from '../ManageBranches/components/EmptyScreen';
import CardHeader from '../../components/CardHeader';
import Debounce from '../../CommonMethods/Debounce';
import ViewBranchUser from '../ManageBranches/ManageBranchUser/ViewBranchUser';
import { AllRolesList } from './roles'

const ManageInstitutionUserList = () => {
    const { isSideNavBar, setToastErrorMessage, setToastmessage,toastErrorMessage } = useContext(GlobalContext);
    const dispatch = useDispatch();
    const InstitutionUserList = useSelector(state => state.InstitutionUserSlice);
    const { List } = InstitutionUserList
    const [loading, setLoading] = useState(true);
    const [loadingActivation, setLoadingActivation] = useState(false);
    const [addOpen, setAddOpen] = useState(false)
    const location = useLocation();
    const [confirmationState, setConfirmationState] = useState({});
    const [sideModelType, setSideModelType] = useState('');
    const [searchParams, setSearchParams] = useSearchParams({page_number: 1});
    const [email, setemail] = useState('');
    const [fistLoading, setFirstLoading] = useState(false)
    const [editValue, setEditValue] = useState({})
    const [openViewPopup, setOpenViewPopup] = useState(false);
    const [selectedinstiUserEmail, setSelectedinstiUserEmail] = useState('');
    const [instiUserData, setinstiUserData] = useState({})
    const [listOfRoles, setListOfRoles] = useState({});
    const [AllRolesList1, setAllRolesList] = useState()
    const [loadingPage,setLoadingPage]=useState(false)
    const initialInputValue = {
        admin_first_name : '',
        admin_last_name: '',
        admin_email_address: '',
        admin_mobile_number:'',
        roles:[]
    }
    const [emptyScreenMessage, setEmptyScreenMessage] = useState('');
    const [inputValue, setInputValue] = useState(initialInputValue);
    const [searchFieldDebounce, setsearchFieldDebounce] = useState(searchParams.get('search') === null ? '' : decodeURIComponent(searchParams.get('search')));
    const [placeholderIndex, setPlaceholderIndex] = useState(0);
    const placeholderOptions = [
        'Name',
        'Email Address',
        'Mobile Number',
    ];

    /* The below code is using the `useEffect` hook in React to set up an interval that changes the
    placeholder index cyclically every 2 seconds. The `setPlaceholderIndex` function is used to update
    the state of the placeholder index based on the previous index value and the length of the
    `placeholderOptions` array. The interval is cleared when the component unmounts to prevent memory
    leaks. */
    useEffect(() => {
        const interval = setInterval(() => {
            // Change placeholder index cyclically
            setPlaceholderIndex(prevIndex => (prevIndex + 1) % placeholderOptions.length);
        }, 2000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        // Convert the AllRolesList object to an array of objects
        const allRolesList1 = Object.entries(AllRolesList).map(([key, value]) => {
            return { [key]: value }; 
        });
        setAllRolesList(allRolesList1)

    }, [])

    /**
     * The function sets the loading state to true and updates the search parameters with a page number
     * of 1.
     */
    const handleLoadData = () => {
        setSearchParams({ page_number:  1 })
    }
    /* `const getBranch` is a function that is defined using the `useCallback` hook. It is used
    to fetch the list of admin users from the server and update the state with the response data.
    The function uses the `dispatch` function from the `useDispatch` hook to dispatch an action
    creator called `AdminUser` with the `searchParams` as an argument. The `AdminUser` action
    creator is responsible for making an API call to fetch the list of admin users from the server.
    Once the API call is successful, the function checks if the `success_status` property of the
    response data is true. If it is true, the function does nothing. If it is false, the function
    sets an error message using the `setToastErrorMessage` function. The `getBranch` function
    is memoized using the `useCallback` hook with the `location` value as a dependency, which means
    that it will only be redefined if the `location` value changes. */
    const getInstitutionUsers = useCallback(async () => {
        setLoading(true); 
        try {
            dispatch(InstitutionUsers(searchParams)).then((response) => {
                if (response?.payload?.data.status===200) {
                    if(response.payload.data.data.data?.length === 0 && searchParams.get('search')===null && response?.payload?.data?.data.total_count === 0 ) {
                        setFirstLoading(true);
                    } else {
                        setEmptyScreenMessage("No matching records found")  
                    }
                    if(Math.ceil(response?.payload?.data?.data.total_count / 10) <  Number(searchParams.get('page_number'))) {
                        if(response?.payload?.data?.data.total_count !== 0) {
                            // setToastErrorMessage('Something went wrong. Please try again')
                            setEmptyScreenMessage("No data found");
                        } else {
                            setEmptyScreenMessage("No matching records found.")
                        }
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                } else {
                    setLoading(false);
                    setEmptyScreenMessage("No data found.");
                    // setToastErrorMessage('Something went wrong. Please try again')
                }
            })
            if(email===''){
                setemail(localStorage.getItem('email'))
            }
        } catch (error) {
            handleLoadData()
            console.error(error);
            setToastErrorMessage(error?.response?.data?.message || "Something Went Wrong")
        }
    }, [location]);

    
    /**
     * This function handles the click event of a page number and updates the search parameters with
     * the selected page number.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    /**
     * This function updates search parameters with a new key-value pair and sets the page number to 1.
     */
    const handleSearchParams = (key, value) => {
        // setLoading(true);
        // setEmptyScreenMessage("We couldn't find anything that matched your search")
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }

    const optimizedFn = useCallback(
        Debounce((key, value) => handleSearchParams(key,value)),
        [searchParams]
    );

    /* `useEffect(() => { getInstitutionUsers(); }, [getInstitutionUsers]);` is a hook that is used to run
    the `getInstitutionUsers` function whenever the `getInstitutionUsers` function changes. In this case,
    the `getInstitutionUsers` function is memoized using the `useCallback` hook, which means that it
    will only be redefined if the `location` value changes. Therefore, the `useEffect` hook will run
    the `getInstitutionUsers` function whenever the `location` value changes. This hook is used to
    fetch the list of admin users from the server and update the `tableData` state with the response
    data. */
    useEffect(() => {
        setsearchFieldDebounce(searchParams.get('search') !== null ? decodeURIComponent(searchParams.get('search')) : '')
        getInstitutionUsers();
    }, [searchParams]);

    /**
     * This function handles the click event for a side popup by resetting an input value and toggling
     * the state of a boolean variable.
     */
    const handleSidePopupClick = (type, item) => {
        if(type === 'Edit') {
            setInputValue({
                admin_first_name : item.first_name,
                admin_last_name: item.last_name,
                admin_email_address: item.email_address,
                admin_mobile_number: item.mobile_number,
                roles: item.roles
            })
            setEditValue(item)
        } 
        else if(type === 'View') {
            getSelectedRoleList(item)
            setOpenViewPopup(true)
            // selectedinstiUserEmail(item)
        }
        else {
            setInputValue(initialInputValue)
        }
        setSideModelType(type)
        setAddOpen(!addOpen);
    }

    const getSelectedRoleList = async (item) => {
        setLoadingPage(true)
        {
            const response = await dataService.GetAPI(`users/${item?.email_address}`);
            if (response.data.status === 200) {
                setinstiUserData(response?.data?.data?.data)
                if (item.user_type==='institution-admin')
                {
                    setListOfRoles(AllRolesList1);    
                }
                setLoadingPage(false);
            } else {
                setLoadingPage(false);

            }

            {
                const getRoleKey = (roleName) => roleName.toLowerCase().replace(/\s/g, '-')
                let filteredRoles = [];
                filteredRoles = AllRolesList1.map(role => {
                    const roleName = Object.keys(role)[0];
                    const subitems = role[roleName];
                    if (subitems.length === 0) {
                        return response?.data?.data?.data?.roles.includes(getRoleKey(roleName)) ? { [roleName]: [] } : null;
                    }
                    const filteredSubitems = subitems.filter(subitem => {
                        const key = roleName === "Employees" && subitem === "Attendance" ? 'employees-attendance' :
                            roleName === "Students-Activity" && subitem === "Attendance" ? 'students-attendance' :
                                subitem.toLowerCase().replace(/\s/g, '-');
                        
                        if (roleName === "Students-Fee" && subitem === "Collect Fee:Receipt") {
                            const anyCollectFeeRoleExists = response?.data?.data?.data?.roles.some(role => role.startsWith("collect-fee:"));
                            return ((response?.data?.data?.data?.roles.includes("collect-fee") && !anyCollectFeeRoleExists) || 
                                    (response?.data?.data?.data?.roles.includes("collect-fee") && response?.data?.data?.data?.roles.includes("collect-fee:receipt")));
                        }
                        return (response?.data?.data?.data?.roles).includes(key);
                    });

                    return filteredSubitems.length > 0 ? { [roleName]: filteredSubitems } : null;
                }).filter(Boolean);

                if (filteredRoles.length > 0) {
                    setListOfRoles(filteredRoles);
                }
            }
        }
    };

    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setConfirmationState({});
    }

    const InstitutionData = JSON.parse(localStorage.getItem('institutionData'));

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async(e) => {
        if(confirmationState.item.user_type === "institution-admin"){
            setConfirmationState({});
            return
        }
        setLoadingActivation(true);
        try {
            let body = { }
            if(confirmationState.status !== "Reset Password") {
                body = {
                    "status": confirmationState.status === 'Activate' ? true : false             
                }
            }
            let endpoint= confirmationState.status==="Reset Password"?`users/reset-password/${confirmationState.item.email_address}`:`users/${confirmationState.item.email_address}`
            if(confirmationState.status==="Reset Password"){
                body={
                    reset:true
                }
            }else{
                body={
                    "status":confirmationState.status==='Deactivate'?false:true,
                }
            }
            const response = await dataService.PatchAPI(body,endpoint);
            const state=confirmationState.status==='Deactivate'?'deactivated':'activated'
            setLoadingActivation(false);
            if(confirmationState.status === 'Reset Password'){
                setToastmessage('Reset password email sent successfully')
            } else{
                setToastmessage(`Institution user ${state} successfully`);
            }
            handleConformationClick();
            getInstitutionUsers()
        } catch (error) {
            handleConformationClick();
            setLoadingActivation(false);
            setToastErrorMessage(error?.response?.data?.message || "Something Went Wrong")
        }
    }
    return (
        <>
            <CardHeader noPadding >
                <TopBarWithShadow
                    AddButton={true}
                    showAddButtonalways={true}
                    SearchInput={true}
                    Tittle={'Institution Users'}
                    AddButtonName={'Add Institution User'}
                    SearchValue={searchFieldDebounce}
                    handleOnClickSearch={setsearchFieldDebounce}
                    optimizedFn={optimizedFn}
                    handleSidePopupClick={handleSidePopupClick}
                    isClick='/manage-institution-users/add-new-user'
                    customSearchPlaceHolder={placeholderOptions[placeholderIndex]}
                    
                /> <CardHeader body>
                    {loading ? <ItemShimmer />
                        : <>
                            <Table
                                handleSidePopupClick={handleSidePopupClick}
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                handleOnClickSort={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setConfirmationState={setConfirmationState}
                                confirmationState={confirmationState}
                                email={email}
                                setLoading={setLoading}
                                searchParams={searchParams}
                                openViewPopup={openViewPopup}
                                setOpenViewPopup={setOpenViewPopup}
                            />
                            {(List.total_count > 10) && <Pagination
                                TotalCount={List.total_count}
                                totalPageNumber={Math.ceil(List.total_count / 10)}
                                selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                                handleOnClickPageNumber={handleOnClickPageNumber}
                            />}
                        </> 
                    }</CardHeader>
            </CardHeader>
            {Object.keys(confirmationState)?.length > 0 && confirmationState?.status  && 
            <AnimatedModel 
                Children={
                    <ConfirmationPrompt 
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle={`${confirmationState.status === 'Reset Password' ? 'Reset Password' : `${confirmationState.status} Institution User`}`}
                        message={confirmationState.item.user_type != "institution-admin"
                            ? `Are you sure you want to ${confirmationState.status === 'Reset Password' 
                                ? `${confirmationState.status} for ${confirmationState.item.first_name} ${confirmationState.item.last_name} ?` 
                                : `${confirmationState.status} ${confirmationState.item.first_name} ${confirmationState.item.last_name} ?`}`
                            : 'You do not have permission to perform this action.'}
                        buttonName={
                            confirmationState.item.user_type  != "institution-admin" ?
                                confirmationState.status === 'Reset Password' ? 'Reset' : confirmationState.status : "Go Back"}
                        loadingActivation={loadingActivation}
                        cancleButton={confirmationState.item.user_type  != "institution-admin" ?
                            confirmationState.status === 'Reset Password' ? undefined : undefined : true   }
                    />
                
                }
            />  
            }
            {openViewPopup && 
                <ViewBranchUser
                    selectedbranchUserEmail={selectedinstiUserEmail}
                    handleSidePopupClick={handleSidePopupClick}
                    openViewPopup={openViewPopup}
                    setOpenViewPopup={setOpenViewPopup}
                    branchUserData={instiUserData}
                    setbranchUserData={setinstiUserData}
                    listOfRoles={listOfRoles}
                    loadingPage={loadingPage}
                    heading={'View Institution User'}
                    enableEdit={false}
                />
            }
        </>
    );
}

export default ManageInstitutionUserList;
